import moment from "moment"
import { useGetQuery } from "hooks/queries"
import { VALIDATE_INTERVAL_MS } from "./use-validate-user-access"

interface SigmaEmbedResponse {
  url: string
  expiresAt: number
}

function getRefreshDelay(expiresAt: number) {
  // Refresh 2x the validate interval before expiration (to make sure validation does not fail)
  let timeToRefresh = moment.unix(expiresAt).subtract(VALIDATE_INTERVAL_MS * 2, "milliseconds")
  if (timeToRefresh.isBefore(moment())) {
    timeToRefresh = moment.unix(expiresAt).subtract(10, "seconds")
  }
  return timeToRefresh.diff(moment(), "milliseconds")
}

/**
 * Fetches the embed URL for a Sigma solution and refreshes it before it expires
 */
export function useFetchEmbedUrl(accountAlias: string, solutionId: string) {
  const { data, isPending, isError, error } = useGetQuery<SigmaEmbedResponse>({
    url: `/api/${accountAlias}/solutions/sigma/${solutionId}/embed`,
    enabled: (query) => query.state.status !== "error",
    refetchInterval: ({ state: { data } }) => data?.expiresAt ? getRefreshDelay(data.expiresAt) : 0,
    refetchIntervalInBackground: true,
    gcTime: 0,
  })

  return {
    embedUrl: data?.url ?? null,
    isPending,
    isError,
    error,
  }
}
